export class ServiceApi {
  /** Получить партнера по Id или номеру */
  GetPartnerOnIdOrNumber: string;

  constructor(url: string) {
    this.GetPartnerOnIdOrNumber = `${url}/api/v1.1/partners/getpartneronidornumber`;
  }
}